<template>
  <div class="side-view" :class="{collapse: $store.state.appMiniWidth}">
    <div class="left-region">
      <slot name="left"></slot>
    </div>
    <div class="right-region">
      <slot name="right"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'SideView'
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';

  .side-view {
    background-color: @color-white;
    &:not(.collapse) {
      display: flex;
      .left-region {
        width: 260px;
        border-right: 1px dashed @color-border-4;
      }
      .right-region {
        flex: 1;
        overflow: hidden;
      }
    }
    &.collapse {
      .left-region {
        border-bottom: 1px dashed @color-border-4;
      }
    }
  }
</style>